import { action } from 'typesafe-actions';
import { WORKGROUP } from '../constants/actions';

export const getList = (payload: any) => action(WORKGROUP.GET_LIST, payload);
export const setList = (payload: any) => action(WORKGROUP.SET_LIST, payload);
export const create = (payload: any) => action(WORKGROUP.CREATE, payload);
export const update = (payload: any) => action(WORKGROUP.UPDATE, payload);
export const reprocess = (payload: any) => action(WORKGROUP.REPROCESS, payload);